// extracted by mini-css-extract-plugin
export default {"root":"CatalogDetails_root__sEV+X"};